export default __webpack_public_path__ + "static/media/Parallax-HUD-Readouts.67ec36f4.jpg";